import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/lb_bids_stats.css */
  .tab {
    cursor: pointer;
    padding: 12px 8px 10px 8px;
    margin: 0 2px;
    background: transparent;
    border-bottom: 0;
    display: flex;
    width: fit-content;
    border-radius: 10px;
    color: rgba(255, 255, 255, 0.5);
    font-size: 0.7rem;
    align-items: center;
  }
  .tab span {
    padding: 3px 5px 3px 5px;
    text-align: center;
    border-radius: 5px;
    margin: -1px 0 0 4px;
    font-size: 0.6rem;
    font-weight: 600;
    display: inline-block;
  }
  .tab span.profit {
    background-color: hsla(126, 100%, 38%, 0.35);
  }
  .tab span.loss {
    background-color: hsla(340, 88%, 46%, 0.35);
    margin-left: 2px;
  }
  .tab:hover {
    background: rgba(255, 255, 255, 0.05);
    font-weight: 600;
    color: #b3cbff;
    text-shadow: 0 0 10px rgba(42, 109, 255, 1);
  }
  #stats_tabs_two:checked ~ .tabs #two-tab {
    background: rgba(255, 255, 255, 0.05);
    font-weight: 600;
    margin-left: -1px;
    color: #b3cbff;
    text-shadow: 0 0 10px rgba(42, 109, 255, 1);
  }
  @media (max-width: 1250px) {
    .tab {
      padding: 10px;
      margin: 0;
      font-size: 0.75rem;
    }
  }
`

const developerCSS = css``

export const YourBidsTabCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
